import FixScroll from '@utils/html/FixScroll';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class CardProduct extends HTMLElement {
	constructor(el) {
		super();
		this.el = this;
		this.btnOpen = this.el.querySelector('.js-open-addtocart');
		this.btnClose = this.el.querySelectorAll('.js-close-addtocart');
		this.btnTrigger = this.el.querySelector('.js-trigger-addtocart');
		this.variants = this.el.querySelector('.js-addtocart-variants');
		this.mainImage = this.el.querySelector('.c-card-product__img--main');
		this.linkTrackings = this.el.querySelectorAll(
			'.js-card-product-click-tracking',
		);

		this.root = document.documentElement;

		this.productTitle = this.el.dataset.productTitle;
		this.productId = this.el.dataset.productId;
		this.productIndex = this.el.dataset.index;
		this.productPrice = this.el.dataset.productPrice;
		this.productOldPrice = this.el.dataset.productCompareAtPrice;
		this.productCoupon = this.el.dataset.productCoupon;
		this.productDiscount = this.el.dataset.productDiscount;
		this.productQuantity = this.el.dataset.productQuantity;
		this.itemCat = this.el.dataset.itemCategory;
		this.itemCat2 = this.el.dataset.itemCategory2;
		this.itemVariant = this.el.dataset.itemVariant;
		this.itemListId = this.el.dataset.itemListId;
		this.itemListName = this.el.dataset.itemListName;
		this.productQuantity = this.el.dataset.productQuantity;
		this.locationId = this.el.dataset.locationId;

		this.previousFocusEl = null;

		this.linkTrackings.forEach((element) => {
			element.addEventListener('click', this.onProductLinkClick.bind(this));
		});
	}

	connectedCallback() {
		if (this.btnOpen) {
			this.openAddToCart();
			this.closeAddToCart();
		}

		if (this.btnTrigger) {
			this.triggerAddToCart();
		}
	}

	openAddToCart() {
		this.btnOpen.addEventListener('click', () => {
			this.previousFocusEl = document.activeElement;
			this.isMobile = Device.width < breakpointsApp.desktop;
			this.el.classList.add('addtocart-open');

			if (this.isMobile) {
				FixScroll.fix();

				if (this.el.closest('.splide__list')) {
					document
						.querySelector('.js-addtocart-mobile')
						.classList.remove('u-hidden');
					document
						.querySelector(
							'.js-addtocart-mobile .c-card-product__addtocart-overlay',
						)
						.classList.remove('u-hidden');
					document.querySelector('.js-addtocart-content').append(this.variants);
					this.variants.classList.remove('u-hidden');
				}
			}

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					this.variants
						?.querySelector('button.js-close-addtocart')
						?.focus({preventScroll: false});
				});
			});
		});
	}

	closeAddToCart() {
		this.btnClose.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.isMobile = Device.width < breakpointsApp.desktop;
				this.el.classList.remove('addtocart-open');

				if (this.isMobile) {
					FixScroll.unFix();

					if (this.el.closest('.splide__list')) {
						document
							.querySelector('.js-addtocart-mobile')
							.classList.add('u-hidden');
						document
							.querySelector(
								'.js-addtocart-mobile .c-card-product__addtocart-overlay',
							)
							.classList.add('u-hidden');
						document.querySelector('.js-addtocart-content').innerHTML = '';
						this.variants.classList.add('u-hidden');
					}
				}

				const restore =
					this.previousFocusEl &&
					typeof this.previousFocusEl.focus === 'function' &&
					document.contains(this.previousFocusEl)
						? this.previousFocusEl
						: this.btnOpen;
				restore?.focus();
				this.previousFocusEl = null;
			});
		});
	}

	triggerAddToCart() {
		this.btnTrigger.addEventListener('click', () => {
			this.el.querySelector('.t-button--addtocart').click();
		});
	}

	onProductLinkClick() {
		const dataLayerPush = {
			ecommerce: null,
		};
		window.dataLayer.push(dataLayerPush);
		const dataLayerPushSelectItem = {
			event: 'select_item',
			ecommerce: {
				currency: window.Shopify.currency.active,
				value: Number(this.productPrice),
				value_nodiscount: Number(this.productOldPrice || this.productPrice),
				items: [
					{
						item_name: String(this.productTitle),
						item_id: String(this.productId),
						// coupon: null,
						discount: Number(this.productDiscount),
						index: Number(this.productIndex || undefined),
						item_category: String(this.itemCat),
						item_category2: String(this.itemCat2),
						// item_category3: null,
						item_list_id: String(this.itemListId || undefined),
						item_list_name: String(this.itemListName || undefined),
						// item_variant: String(this.itemVariant),
						location_id: String(this.locationId),
						price: Number(this.productPrice),
						price_nodiscount: Number(this.productOldPrice || this.productPrice),
						quantity: String(this.productQuantity),
					},
				],
			},
		};
		window.dataLayer.push(dataLayerPushSelectItem);
	}
}
